import formatDate from 'date-fns/format';
import { Editor } from 'grapesjs';
import { ParticipantFrontendContext, formatNumber } from '@loyalty/editor-components';

export function buildParticipantContextFromGrape(
  grapeI18n: Editor['I18n'],
): ParticipantFrontendContext {
  const locale = grapeI18n.getLocale();
  const dateFormat = grapeI18n.t('dateFormat') ?? 'dd/MM/yyyy';

  const tr = grapeI18n.t.bind(grapeI18n); // purposely done to trick i18next-parser

  return {
    i18n: {
      dateFormat,
      locale,
      t: (key, params) => tr(key, { params }),
      formatNumber: (value: number, options?: Intl.NumberFormatOptions) =>
        formatNumber(value, { locale, ...options }),
      formatDate: (date: Date | string) =>
        formatDate(typeof date === 'string' ? new Date(date) : date, dateFormat),
    },
    displayDebug: true,
    isInEditor: true,
  };
}
